<script>
import baseList from "@/views/components/base/baseList.vue";
import addVue from "./add.vue";
let customerId = window.localStorage.getItem("customerId");

export default {
  extends: baseList,
  components: {
    addVue,
  },
  data() {
    return {
      table: {
        mname: "scheduling",
        key: "id",
        url: {
          list: "/admin/system/date/list",
        },
        output: false,
      },
      actions: [
        {
          label: "新增排班",
          icon: "md-add",
          type: "info",
          onClick: this.toAdd,
          auth: "",
        },
      ],
      filters: [],
      menus: [
        {
          label: "排班管理",
          name: "scheduling_list",
          auth: "",
        },
        {
          label: "考勤组",
          name: "attendance_list",
          auth: "",
        },
      ],
      tableCols: [
        {
          key: "classesDate",
          title: "排班月份",
          // width: 300,
          align: "center",
        },
        {
          key: "handle",
          title: "操作",
          // width: 300,
          align: "center",
          handle: [
            (vm, h, currentRow, param) => {
              console.log(param);
              let row = param.row;
              return (
                <Button
                  size="small"
                  onClick={() => this.toInfo(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginRight: "5px",
                  }}
                >
                  详情
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              let row = param.row;
              return (
                <Button
                  size="small"
                  onClick={() => this.toDel(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginRight: "5px",
                  }}
                >
                  删除
                </Button>
              );
            },
          ],
        },
      ],
    };
  },
  created() { },
  methods: {
    toAdd() {
      this.$Modal.success({
        closable: true,
        title: "新增排班",
        width: "800px",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return <addVue onCloseModal={(e) => this.closeModal(e)} />;
        },
      });
    },
    closeModal(e) {
      this.$Modal.remove();
      if (e) {
        this.search();
        $utils.toast.success("新增成功");
      }
    },
    toInfo(item) {
      $utils.url.push({
        name: "scheduling_details",
        query: { id: item.id, time: item.classesDate },
      });
    },
    toDel(row) {
      console.log(row);
      $utils.api.load(`/admin/system/date/${row.id}`, {}, "DELETE").then((res) => {
        if (res.code == 200) {
          this.search();
          $utils.toast.success("删除成功");
        }
      });
    },
  },
};
</script>

<style></style>
